import React, { useState, useRef } from 'react';
import { Modal, Button, Box, SpaceBetween, Alert } from '@cloudscape-design/components';
import axios from 'axios';

const AvatarUpload = ({ visible, onDismiss, member, familyId, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState('');
  const fileInputRef = useRef(null);

  // 处理文件选择
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // 验证文件类型
    if (!file.type.startsWith('image/')) {
      setError('请选择图片文件');
      return;
    }

    // 验证文件大小 (限制为2MB)
    if (file.size > 2 * 1024 * 1024) {
      setError('图片大小不能超过2MB');
      return;
    }

    setError('');

    // 读取文件并转换为Base64
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64Data = e.target.result;
      setPreview(base64Data);
    };
    reader.readAsDataURL(file);
  };

  // 上传头像
  const handleUpload = async () => {
    if (!preview) {
      setError('请先选择图片');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.post(
        `/api/families/${familyId}/members/${member.id}/avatar`,
        {"family_id": familyId,
          "member_id": member.id,
          "avatar_base64": preview
        }
      );
      if (onSuccess) {
        onSuccess(member.id, preview);
      }

      // 关闭对话框
      handleClose();
      
      alert(`✅ ${member.name} 的头像更新成功！`);
      
    } catch (error) {
      console.error('头像上传失败:', error);
      setError(error.response?.data?.detail || '上传失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  // 关闭对话框
  const handleClose = () => {
    setPreview(null);
    setError('');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    onDismiss();
  };

  // 触发文件选择
  const triggerFileSelect = () => {
    fileInputRef.current?.click();
  };

  return (
    <Modal
      onDismiss={handleClose}
      visible={visible}
      size="medium"
      header={`更新 ${member?.name} 的头像`}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button key="cancel" variant="link" onClick={handleClose}>
              取消
            </Button>
            <Button 
              key="submit"
              variant="primary" 
              onClick={handleUpload}
              loading={loading}
              disabled={!preview}
            >
              {loading ? '上传中...' : '确认上传'}
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size="m">
        {error && (
          <Alert key="error" type="error" dismissible onDismiss={() => setError('')}>
            {error}
          </Alert>
        )}

        {/* 当前头像预览 */}
        <div key="current" style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: '1rem' }}>
            <strong>当前头像：</strong>
          </div>
          <div style={{
            width: '120px',
            height: '120px',
            borderRadius: '50%',
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '2px solid #ddd',
            fontSize: '3rem',
            overflow: 'hidden'
          }}>
            {preview ? (
              <img 
                src={preview} 
                alt="预览" 
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            ) : member?.avatar && member.avatar.startsWith('data:image/') ? (
              <img 
                src={member.avatar} 
                alt={member.name} 
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            ) : (
              <span>{member?.avatar || '👤'}</span>
            )}
          </div>
        </div>

        {/* 文件选择 */}
        <div key="upload" style={{ textAlign: 'center' }}>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={handleFileSelect}
            style={{ display: 'none' }}
          />
          <Button 
            variant="normal" 
            onClick={triggerFileSelect}
            iconName="upload"
          >
            选择新头像
          </Button>
        </div>

        {preview && (
          <div key="preview" style={{ textAlign: 'center' }}>
            <div style={{ marginBottom: '1rem' }}>
              <strong>新头像预览：</strong>
            </div>
            <div style={{
              width: '120px',
              height: '120px',
              borderRadius: '50%',
              margin: '0 auto',
              overflow: 'hidden',
              border: '3px solid #007dbc'
            }}>
              <img 
                src={preview} 
                alt="新头像预览" 
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            </div>
          </div>
        )}

        <div key="notice" style={{ 
          fontSize: '0.9rem', 
 
          textAlign: 'center',
          padding: '1rem',

          borderRadius: '0.5rem'
        }}>
          <div>📝 <strong>上传说明：</strong></div>
          <div>• 支持 JPG、PNG、GIF 格式</div>
          <div>• 文件大小不超过 2MB</div>
          <div>• 建议使用正方形图片，效果更佳</div>
        </div>
      </SpaceBetween>
    </Modal>
  );
};

export default AvatarUpload;